import { render, staticRenderFns } from "./SecondaryCaseDetailRoute.vue?vue&type=template&id=3e005d39"
import script from "./SecondaryCaseDetailRoute.vue?vue&type=script&lang=js"
export * from "./SecondaryCaseDetailRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports